import { render } from "./articleList.vue?vue&type=template&id=5a9d92ab&scoped=true"
import script from "./articleList.vue?vue&type=script&lang=js"
export * from "./articleList.vue?vue&type=script&lang=js"

import "./articleList.vue?vue&type=style&index=0&id=5a9d92ab&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9d92ab"]])

export default __exports__